import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptor';
import { extractErrorMessage } from '../utils/errorHandler';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup auth interceptors (includes token refresh on 401)
setupAuthInterceptors(apiClient, 'Categories');

export const getCategories = async () => {
  try {
    const response = await apiClient.get('/categories/');
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const getCategoryById = async (id) => {
  try {
    const response = await apiClient.get(`/categories/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const createCategory = async (data) => {
  try {
    const response = await apiClient.post('/categories/', data);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await apiClient.patch(`/categories/${id}/`, data);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await apiClient.delete(`/categories/${id}/`);
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error));
  }
};
